var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.imageErrored)?_c('span',{staticClass:"media-library-thumb-extension"},[_c('span',{staticClass:"media-library-thumb-extension-truncate"},[_vm._v(_vm._s(_vm.name.split('.').pop()))])]):_c('img',{staticClass:"media-library-thumb-img border-0 rounded",attrs:{"src":_vm.client_preview},on:{"error":function($event){_vm.imageErrored = true}}})
}
var staticRenderFns = []

export { render, staticRenderFns }